"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentMessage = void 0;
const Cell_1 = require("../boc/Cell");
class CommentMessage {
    constructor(comment) {
        this.comment = comment;
    }
    writeTo(cell) {
        if (this.comment.length > 0) {
            cell.bits.writeUint(0, 32);
            let bytes = Buffer.from(this.comment);
            let dest = cell;
            while (bytes.length > 0) {
                let avaliable = Math.floor(dest.bits.available / 8);
                if (bytes.length <= avaliable) {
                    dest.bits.writeBuffer(bytes);
                    break;
                }
                dest.bits.writeBuffer(bytes.slice(0, avaliable));
                bytes = bytes.slice(avaliable, bytes.length);
                let nc = new Cell_1.Cell();
                dest.refs.push(nc);
                dest = nc;
            }
        }
    }
}
exports.CommentMessage = CommentMessage;
